import { downAndDistance, fieldPosition } from '../sim/drive';
import { clockText, type MatchState } from '../sim/match';
import type { DriveState } from '../sim/types';
import { el } from './dom';

/** Score bug across the top (reference 01, BRAND placement 11): down and distance, teams and score, clock. */
export class Hud {
  readonly root = el('div', 'scorebug');
  private readonly down = el('div', 'sb-down');
  private readonly spot = el('div', 'sb-spot');
  private readonly home = el('div', 'sb-team sb-home');
  private readonly homeScore = el('div', 'sb-score');
  private readonly awayScore = el('div', 'sb-score');
  private readonly away = el('div', 'sb-team sb-away');
  private readonly clock = el('div', 'sb-clock');

  constructor(homeName: string, awayName: string) {
    this.home.textContent = homeName.toUpperCase();
    this.away.textContent = awayName.toUpperCase();
    this.root.append(this.down, this.spot, this.home, this.homeScore, this.awayScore, this.away, this.clock);
    this.root.dataset.testid = 'scorebug';
  }

  update(drive: DriveState, match: MatchState): void {
    this.down.textContent = downAndDistance(drive);
    this.spot.textContent = fieldPosition(drive.ballOn);
    this.homeScore.textContent = String(match.home);
    this.awayScore.textContent = String(match.away);
    this.clock.textContent = clockText(match);
  }

  /** Score and clock only (the down and spot stay as they are). */
  setScore(match: MatchState): void {
    this.homeScore.textContent = String(match.home);
    this.awayScore.textContent = String(match.away);
    this.clock.textContent = clockText(match);
  }

  setClock(match: MatchState): void {
    this.clock.textContent = clockText(match);
  }

  flashScore(): void {
    this.root.classList.remove('flash');
    void this.root.offsetWidth;
    this.root.classList.add('flash');
  }
}
